import { Component, OnInit, Inject } from "@angular/core"
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: "rm-view-plans",
    templateUrl: "./view-plans.component.html",
    styleUrls: ["./view-plans.component.css"]
})

export class ViewPlansComponent implements OnInit {

    dialgTitle:any;

    constructor(
        private dialogRef: MatDialogRef<ViewPlansComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }
    ngOnInit() {
        this.dialgTitle = this.data.title;
    }
    onSubmit(values) {
        this.dialogRef.close(values);
    }
}